module.exports = __webpack_public_path__ + "static/media/wall.289f64ee.svg";